module.exports = __webpack_public_path__ + "static/img/347_phase_function_Paper_PointsHejduk_Prediction.c401e05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/347_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nD8P
// module chunks = 0